<template lang="pug">
  info-documentos-cadastro
</template>

<script>
const InfoDocumentosCadastro = () => import('@/screens/portal/publico/components/estados/' + process.env.ESTADO + '/componentes/InfoDocumentosCadastro')

export default {
  components: {
    InfoDocumentosCadastro
  }
}

</script>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/informacao/DocumentosCadastro.vue